import React, { ReactNode } from "react";
import styled from "styled-components";
import {
  getNewLookTokens,
  NEW_LOOK_RADIUS,
  newLookType,
} from "common/NewLook/tokens.ts";

interface SectionHeaderProps {
  title: ReactNode;
  /** Shown as a small pill next to the title. */
  count?: ReactNode;
  /** Extra content next to the title (tags, info tooltips). */
  extra?: ReactNode;
  /** Right-aligned controls (links, sort, arrows). */
  actions?: ReactNode;
  className?: string;
}

const SectionHeader = ({
  title,
  count,
  extra,
  actions,
  className,
}: SectionHeaderProps) => (
  <Wrapper className={className}>
    <Title>{title}</Title>
    {count !== undefined && <Count>{count}</Count>}
    {extra}
    {actions && <Actions>{actions}</Actions>}
  </Wrapper>
);

export default SectionHeader;

const Wrapper = styled.div`
  flex-wrap: wrap;
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 32px;
  margin-bottom: 12px;
  @media (max-width: 600px) {
    gap: 6px;
    margin-bottom: 8px;
  }
`;
const Title = styled.h2`
  margin: 0;
  ${newLookType.panelTitle};
  font-size: 15px;
  color: ${(p) => getNewLookTokens(p.theme).ink};
`;
// The same quiet count as a panel header (not a tinted pill).
const Count = styled.span`
  ${newLookType.meta};
  font-weight: 500;
  min-width: 20px;
  padding: 1px 6px;
  border-radius: ${NEW_LOOK_RADIUS.chip}px;
  background: ${(p) => getNewLookTokens(p.theme).well};
  box-shadow: inset 0 0 0 1px ${(p) => getNewLookTokens(p.theme).hairline};
  color: ${(p) => getNewLookTokens(p.theme).secondary};
  text-align: center;
`;
const Actions = styled.div`
  flex-wrap: wrap;
  min-width: 0;
  margin-left: auto;
  display: flex;
  align-items: center;
  gap: 8px;
`;
